import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PatientsystemexaminationParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}


export interface PatientsystemexaminationMst {
    id?: number;      
    visitId:any;
    regId: string;     
    tenantId: any;
    branchId: any;
    cvs : string;
	rs  : string;	
	cns : string;	
	pa  : string;
	localExamination : string;
    
    //Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    parameters?: PatientsystemexaminationParameter[];
    links?: any;
}
export abstract class PatientsystemexaminationData { 

    abstract list(url: string): Observable<PatientsystemexaminationMst[]>;
    abstract create(url: string, data: PatientsystemexaminationMst): Observable<any>;
    abstract update(url: string, data: PatientsystemexaminationMst): Observable<any>;
    abstract delete(url: string): Observable<any>;    
}
